import { storefrontAppearanceAtom } from "@/atoms/storefront-appearance";
import type { StorefrontAppearance } from "@/domain/storefront-appearance";
import { useAtomValue } from "jotai";

/**
 * Appearance the storefront is drawing. Always a valid object — readers never
 * ask if it loaded. READ-ONLY; `loadStorefrontAppearance` fetches outside React
 * so it can start before the first render.
 */
export function useStorefrontAppearance(): StorefrontAppearance {
  return useAtomValue(storefrontAppearanceAtom);
}
